import useAircraft from "./useAircraft";

const useColors = aircraftIdent => {
	if (!["string", "number"].includes(typeof aircraftIdent)) {
		throw new TypeError(
			`Expected a value of type string or number for \`aircraftIdent\` but got ${typeof aircraftIdent}`
		);
	}

	const aircraft = useAircraft(aircraftIdent);
	if (!aircraft) return [null, null];
	return getColorByAircraftStatus(aircraft.status, aircraft.grounded);
};

function getColorByAircraftStatus(status, grounded = false) {
	if (grounded) return ["red", "red"];
	if (status === "delivery") return ["purple", "purple"];
	if (status === "landed") return ["green", "darkGreen"];
	if (status === "cleaning") return ["orange", "orange"];
	return ["blue", "darkBlue"];
}

export default useColors;
export { useColors, getColorByAircraftStatus };
